import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CommonModal from '../../../../../../../components/common-modal/CommonModal';
import ContentSlider from '../../../../../content-slider/ContentSlider';
import ContentSlide from '../../../../../content-slide/ContentSlide';
import TagList from '../../../../../tag-list/TagList';
import TooltipButton from '../../../../../../../components/tooltip-button/TooltipButton';
import { BUTTON_STYLES } from '../../../../../../../components/common-button/CommonButton';
import Icon from '../../../../../../../icons/Icon';
import { ICONS } from '../../../../../../../icons';

import scss from './DuplicatesModal.module.scss';

function DuplicatesModal({ isOpen, onClose, duplicates = [], onSkip, onAddAnyway }) {
  const { t } = useTranslation('activ8');
  const [slideIndex, setSlideIndex] = useState(0);

  const handleSwipe = (_, next) => {
    setSlideIndex(next);
  };

  const tags = useMemo(() => {
    return duplicates?.[slideIndex]?.tags ?? [];
  }, [duplicates, slideIndex]);

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <div className={scss.wrapper}>
        <h3 className={scss.title}>{t('similarFileDetected')}</h3>

        <ContentSlider slides={duplicates} Slide={ContentSlide} index={slideIndex} onSwipe={handleSwipe} />
        <TagList tags={tags} isExpandable />

        <div className={scss.infoBlock}>
          <Icon icon={ICONS.Info} disableCommonColors className={scss.infoIcon} />

          <div className={scss.textContent}>
            <span className={scss.subTitle}>{t('weFoundMatchingOrSimilarMediaInThisProject')}</span>
            <span className={scss.subTitle}>{t('youCanSkipThisUploadOrContinueAnyway')}</span>
          </div>
        </div>

        <div className={scss.actions}>
          <TooltipButton styleColor={BUTTON_STYLES.SECONDARY} maxWidth={160} onClick={onAddAnyway}>
            {t('addAnyway')}
          </TooltipButton>
          <TooltipButton styleColor={BUTTON_STYLES.PRIMARY} maxWidth={160} onClick={onSkip}>
            {t('skip')}
          </TooltipButton>
        </div>
      </div>
    </CommonModal>
  );
}

export default DuplicatesModal;
